import React, { useEffect } from 'react';
import styles from './index.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { getOnSaleCount, getOrderCountByMonth, getOrderCountByPreviousMonth, getSales, getSoldCount, getVehicleCountByMonth } from '../../../redux/features/dashboard/dashboardService';
import BarChart from '../../../components/Stats/BarChart';
import ScatterChart from '../../../components/Stats/ScatterChart';
import Skeleton from 'react-loading-skeleton';
import { faMoneyBill, faVanShuttle } from '@fortawesome/free-solid-svg-icons';
import Card from '../../../components/Card';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import { selectUserDetails } from '../../../redux/features/auth/authSlice';

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
};

const SpecialistDashboard = () => {

  const dispatch = useDispatch();

  const { sales } = useSelector((state) => state.dashboard.sales);
  const { quantity } = useSelector((state) => state.dashboard.vehicleQuantity);
  const { isCountLoading, count } = useSelector((state) => state.dashboard.onSaleVehicleCount);
  const { isSoldCountLoading, soldCount } = useSelector((state) => state.dashboard.soldVehicleCount);
  const { isOrderLoading, orderCount } = useSelector((state) => state.dashboard.orderCount);
  const { isPreviousOrderLoading, previousMonthOrderCount } = useSelector((state) => state.dashboard.previousMonthOrderCount);

  const { details } = useSelector(selectUserDetails);

  useEffect(() => {
    const date = new Date();
    const month = formatDate(date);
    const previousMonthDate = new Date(date.getFullYear(), date.getMonth() - 1, date.getDate());
    const previousMonth = formatDate(previousMonthDate);
    dispatch(getSales({ months: 7, agent_id: details?.id }));
    dispatch(getVehicleCountByMonth({ count: 7 }));
    dispatch(getOnSaleCount({}));
    dispatch(getSoldCount({}));
    dispatch(getOrderCountByMonth({ month: month, agent_id: details?.id }));
    dispatch(getOrderCountByPreviousMonth({ month: previousMonth, agent_id: details?.id }));
  }, [dispatch]);

  // Line Chart
  const dataValues = sales?.map(item => parseInt(item.count, 10));
  const labels = sales?.map(item => {
    return (item.month);
  });

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Vehicle Sales',
        data: dataValues,
        borderColor: '#6F3EFB',
        backgroundColor: '#6F3EFB',
        showLine: true,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
        },
        ticks: {
          stepSize: 50,
        },
      },
    },
  };

  return (
    <div>
      <div className={styles.cardContainer}>
        <div className={styles.topCardContainer}>
          <Card place="one" icon={faVanShuttle} text='On Sale Vehicles' number={isCountLoading ? <Skeleton /> : count} />
        </div>
        <div className={styles.middleCardContainer}>
          <Card place="two" icon={faMoneyBill} text='Sold Vehicle Count' number={isSoldCountLoading ? <Skeleton /> : soldCount} />
        </div>
        <div className={styles.bottomCardContainer}>
          <Card place="three" icon={faCalendarDays} text='This Month Order Count' number={isOrderLoading ? <Skeleton /> : orderCount} />
        </div>
        <div className={styles.fourthCardContainer}>
          <Card place="four" icon={faCalendarDays} text='Previous Month Order Count' number={isPreviousOrderLoading ? <Skeleton /> : previousMonthOrderCount} />
        </div>
      </div>
      <div className={styles.graphContainer}>
        <div className={styles.lineChartContainer}>
          <ScatterChart
            chartData={chartData}
            chartOptions={options}
            label="Vehicle Sales" />
        </div>
        <div className={styles.barChartContainer}>
          <BarChart
            chartTitle='Vehicle Count'
            quantity={quantity}
          />
        </div>
      </div>
    </div>
  );
};

export default SpecialistDashboard;
